export default "__VITE_ASSET__rqJJhXzt__"